import React from "react";
import "./gradient-tick-button.css";

const GradientButton = () => {
  return (
    <div className="gradient-check-button">
      <img
        src="assets/images/upper-arrow.png"
        width={12}
        height={12}
        alt="gradient-button"
      />
    </div>
  );
};

export default GradientButton;
